<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
    viewBox="0 0 25 25"
  >
    <path
      d="m419 159-11-9 21-29c14-16 20-36 17-57-4-19-16-36-33-47a80 80 0 0 0-46-17c-23 1-45 14-57 34L91 335c-21 28-34 103-37 126a34 34 0 0 0 49 35c19-10 88-46 108-74l177-244 11 8c4 3 6 6 7 10v7l-51 71a17 17 0 0 0 28 19l51-70c7-10 9-23 6-35s-10-22-20-29h-1ZM183 402c-17 24-96 64-96 64s14-87 32-111l177-244 64 48-177 243Zm219-301-22 29-65-47 22-29c10-14 19-20 29-20 10 1 19 5 26 11 23 17 27 32 9 56h1Z"
      style="fill-rule: nonzero"
      transform="matrix(.05 0 0 .05 0 0)"
    />
  </svg>
</template>
